import React from 'react';

import { Link, useNavigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';

import genericModelTypes from '../provider/models/genericModelTypes';
import { sendPost } from '../provider/models/reservationModel';
import { changedContactForm, sentForm } from '../store/actions';
import { env } from '../utils/env';
import BackButton from './BackButton/BackButton';
import Button from './Button/Button';
import FormField from './FormField/FormField';
import FormLabel from './FormLabel/FormLabel';
import styles from './Pages/SingleInputPage/SingleInputPage.module.scss';

export default function CompactContactForm({
  genericType,
  setLoading,
  backButtonLink,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentService = useSelector((store) => store.state.service);
  const currentFranchise = useSelector((store) => store.state.city.franchise);
  const currentAge = useSelector((store) => store.state.age);

  const currentForm = useSelector((store) => store.state.contactForm);
  const formPageTexts = useSelector((store) => store.data.formPage);

  const isFilled = () => currentForm.phone.valid || currentForm.email.valid;

  const handleSend = () => {
    setLoading(true);

    let data = {
      genericType: genericType,
      email: currentForm.email.text,
      mobile: currentForm.phone.text,
      comment: currentForm.comment.text,
    };

    switch (genericType) {
      case genericModelTypes.noService:
        data = {
          ...data,
          genericInfo: {
            service: currentService,
            franchise: currentFranchise,
          },
        };
        break;

      case genericModelTypes.noLevel:
        data = {
          ...data,
          genericInfo: {
            service: currentService,
            franchise: currentFranchise,
            age: currentAge,
          },
        };
        break;

      default:
        break;
    }

    sendPost(data, 'generic').then((isOk) => {
      if (isOk) {
        dispatch(sentForm('generic'));
        navigate(`${env.PUBLIC_URL}/thanks`);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      <FormLabel>{formPageTexts.phoneLabel}</FormLabel>
      <FormField
        type={'phone'}
        hint={'000-000-000'}
        value={currentForm.phone.text}
        valid={currentForm.phone.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'phone', text: value, valid: valid }),
          )
        }
      />
      <FormLabel>{formPageTexts.emailLabel}</FormLabel>
      <FormField
        type={'email'}
        hint={'jan.kowalski@gmail.com'}
        value={currentForm.email.text}
        valid={currentForm.email.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'email', text: value, valid: valid }),
          )
        }
      />

      <FormLabel>{formPageTexts.commentLabel}</FormLabel>
      <FormField
        value={currentForm.comment.text}
        valid={currentForm.comment.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'comment', text: value, valid: valid }),
          )
        }
      />

      <div className={styles.navWrapper} style={{ marginTop: 16 }}>
        <Link to={backButtonLink || `../`}>
          <BackButton />
        </Link>
        <Button
          disabled={!isFilled()}
          type={'primary'}
          text={'Wyślij'}
          onClick={handleSend}
        />
      </div>
    </>
  );
}
